import React from 'react';

import { Body, Modal } from '@icarros/ids-react';

import { useAdContext } from '../../../../../store/contexts/ad';

interface SaveOnBackModalProps {
  modalOpen: boolean;
  setModalOpen(value: boolean): void;
  closeEditPage(): void;
}

export function SaveOnBack({
  modalOpen,
  setModalOpen,
  closeEditPage
}: SaveOnBackModalProps): JSX.Element {
  const { setSubmitOnModalClick } = useAdContext();

  return (
    <Modal
      stateOpen={[modalOpen, setModalOpen]}
      body={
        <Body size="body_2" contrast="default" weight="regular" variant="base">
          Suas alterações ainda não foram salvas. Confirme agora para salvar.
        </Body>
      }
      title="deseja confirmar as alterações?"
      mainButtonText="confirmar"
      mainButtonMethod={() => {
        setSubmitOnModalClick(true);
        setModalOpen(false);
      }}
      secondaryButtonText="não salvar"
      secondaryButtonMethod={() => {
        closeEditPage();
        setModalOpen(false);
      }}
    />
  );
}
